export default "__VITE_ASSET__BppJltGv__"